<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
import AppLogoIcon from '@/components/AppLogoIcon.vue';

defineProps<{
    title: string;
    description?: string;
}>();
</script>

<template>
    <div class="relative flex min-h-dvh flex-col items-center justify-center overflow-hidden bg-white px-4 py-12 text-foreground dark:bg-zinc-950">
        <div class="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(139,92,246,0.12),_transparent_55%)]" />
        <div class="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,_rgba(34,211,238,0.08),_transparent_45%)]" />

        <main class="relative z-10 w-full max-w-md">
            <Link href="/" class="mb-8 flex items-center justify-center gap-2.5">
                <AppLogoIcon uid="auth" class="size-8" />
                <span class="font-display text-xl font-bold tracking-tight">CreativeTint</span>
            </Link>

            <div class="rounded-2xl border border-zinc-200 bg-white/80 p-6 shadow-sm backdrop-blur dark:border-zinc-800 dark:bg-zinc-900/70 sm:p-8">
                <div class="mb-6 text-center">
                    <h1 class="font-display text-2xl font-bold tracking-tight">{{ title }}</h1>
                    <p v-if="description" class="mt-2 text-sm text-muted-foreground">{{ description }}</p>
                </div>
                <slot />
            </div>
        </main>
    </div>
</template>
